import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import { DocumentMetaData, MetaFields, UpdateCanonicalPayload } from "./document-meta.model";

const ACTION_PREFIX = "[Document Meta]";
export const DOCUMENT_META_DATA_ACTION_TYPE = {
	set: `${ACTION_PREFIX} Set ${SYNC_SUFFIX}`,
	setMetaData: `${ACTION_PREFIX} Set Meta Data ${SYNC_SUFFIX}`,
	setMetaDataFromConfig: `${ACTION_PREFIX} Update Meta Title ${SYNC_SUFFIX}`,
	updateMetaTitle: `${ACTION_PREFIX} Update Meta Title ${SYNC_SUFFIX}`,
	updateCanonical: `${ACTION_PREFIX} Update Canonical ${SYNC_SUFFIX}`,
	initializeOverride: `${ACTION_PREFIX} Initialize Override ${SYNC_SUFFIX}`,
	initializeOverrideFail: `${ACTION_PREFIX} Initialize Override Fail ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class DocumentMetaAction {
	set(payload: DocumentMetaData): ActionWithPayload {
		return {
			type: DOCUMENT_META_DATA_ACTION_TYPE.set,
			payload,
		};
	}

	setMetaData(payload: MetaFields): ActionWithPayload {
		return {
			type: DOCUMENT_META_DATA_ACTION_TYPE.setMetaData,
			payload,
		};
	}

	setMetaDataFromConfig(): Action {
		return {
			type: DOCUMENT_META_DATA_ACTION_TYPE.setMetaDataFromConfig,
		};
	}

	updateMetaTitle(payload: string): ActionWithPayload {
		return {
			type: DOCUMENT_META_DATA_ACTION_TYPE.updateMetaTitle,
			payload,
		};
	}

	updateCanonical(payload: UpdateCanonicalPayload): ActionWithPayload {
		return {
			type: DOCUMENT_META_DATA_ACTION_TYPE.updateCanonical,
			payload,
		};
	}

	initializeOverride(isQueryParamsChangeOnly = false, requestQueryParams?: Record<string, any>): ActionWithPayload {
		return {
			type: DOCUMENT_META_DATA_ACTION_TYPE.initializeOverride,
			payload: { isQueryParamsChangeOnly, requestQueryParams },
		};
	}

	initializeOverrideFail(error: AppError | Error): ActionWithPayload {
		return {
			type: DOCUMENT_META_DATA_ACTION_TYPE.initializeOverrideFail,
			payload: error,
		};
	}
}
